import React from "react";

import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/base-components/Icon";
import { ModelProvider } from "src/clients/agent-management";
import { Tooltip } from "src/design-system/Tooltip";
import { ModelOptionBadgeConfig } from "src/genai/ModelSelector/types";

type ModelOptionBadgeProps = {
  badgeConfig: ModelOptionBadgeConfig;
};

export const ModelOptionBadge: React.FC<ModelOptionBadgeProps> = ({
  badgeConfig,
}) => {
  return (
    <Tooltip body={badgeConfig.tooltip} placement="right" asChild>
      <div
        className={`flex h-5 shrink-0 items-center rounded pr-1 pl-2 ${badgeConfig.className}`}
      >
        <span className="font-inter-normal-12px">{badgeConfig.label}</span>
        <Icon icon={faInfoCircle} size="2xs" />
      </div>
    </Tooltip>
  );
};

/**
 * Pre-configured badges for specific providers.
 * Consumers can use these configs when adapting models.
 */
export const PROVIDER_BADGE_CONFIG: Partial<
  Record<ModelProvider, ModelOptionBadgeConfig>
> = {
  bedrock: {
    label: "Taktile-hosted",
    tooltip:
      "This model is hosted by Taktile via AWS Bedrock for additional privacy. This might come with lower usage limits.",
    className: "bg-gray-100 text-gray-600",
  },
};

/**
 * Badge config for deprecated models.
 */
export const DEPRECATED_BADGE_CONFIG: ModelOptionBadgeConfig = {
  label: "Deprecated",
  tooltip:
    "This model version is deprecated and will be removed soon. Please use Claude 4.5 for the most up to date model capabilities.",
  className: "bg-orange-50 text-orange-600",
};
